export default "__VITE_ASSET__DCcmmLHl__"